<template>
  <svg
    width="16px"
    height="16px"
    viewBox="0 0 16 16"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <!-- Generator: Sketch 63.1 (92452) - https://sketch.com -->
    <title>logout</title>
    <desc>Created with Sketch.</desc>
    <g id="控件" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g
        id="账户"
        transform="translate(-170.000000, -6.000000)"
        fill="#003399"
        fill-rule="nonzero"
      >
        <g id="编组" transform="translate(170.000000, 6.000000)">
          <path
            d="M8,3.11218838e-06 C9.98952246,-0.00175279776 11.907971,0.739567402 13.3793499,2.07867209 C13.5102207,2.19747089 13.5885242,2.36340261 13.5970263,2.53994718 C13.6055285,2.71649175 13.5435326,2.88918009 13.4246833,3.02000505 C13.1773497,3.29333828 12.7560158,3.3126716 12.4826821,3.06533837 C11.2563972,1.94973601 9.65782353,1.33208468 8,1.33333905 C4.32400536,1.33333905 1.33333499,4.32400455 1.33333499,8.00000311 C1.33333499,11.6766683 4.32400536,14.6666672 8,14.6666672 C9.65601197,14.6666672 11.2433473,14.0560008 12.4693488,12.9466679 C12.6002824,12.8278498 12.7731035,12.765997 12.9496956,12.7747516 C13.1262876,12.7835061 13.2921436,12.8621488 13.4106833,12.9933345 C13.5293673,13.1243309 13.5911311,13.2971212 13.5823787,13.4736695 C13.5736263,13.6502178 13.4950751,13.816052 13.3640166,13.9346675 C11.8926814,15.2666669 9.98734571,16.0000031 8,16.0000031 C3.58867112,16.0000031 0,12.4112014 0,8.00000311 C0,3.58933816 3.58867112,3.11218838e-06 8,3.11218838e-06 Z M13.3333499,4.86133767 L15.8053529,7.40467001 C15.9409025,7.54042023 16.0112748,7.72806318 15.9984198,7.91946982 C16.0005267,7.95005578 16.0005267,7.98075047 15.9984198,8.01133644 C16.011314,8.20278838 15.9409387,8.39048793 15.8053529,8.52626958 L13.3333499,11.0696019 C13.0726225,11.3289039 12.6514093,11.3289039 12.390682,11.0696019 C12.1313797,10.808875 12.1313797,10.3876625 12.390682,10.1269356 L13.8436172,8.63200286 L5.33333995,8.63213619 C4.96667282,8.63213619 4.66667246,8.33213631 4.66667246,7.96546979 C4.66667246,7.59880328 4.96667284,7.29880339 5.33333995,7.29880339 L13.8436172,7.29880339 L12.390682,5.80400397 C12.1313797,5.54327707 12.1313797,5.12206457 12.390682,4.86133767 C12.6514093,4.60203573 13.0726225,4.60203573 13.3333499,4.86133767 Z"
            id="logout"
          ></path>
        </g>
      </g>
    </g>
  </svg>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'Logout'
});
</script>
